import { BrowserModule } from '@angular/platform-browser';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BzTabModule } from './../shared/components/tab/tab.module';
import { CommonModule } from '@angular/common';
import { BzSwitchModule } from '../shared/components/switch/switch.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { FormsModule } from '@angular/forms';
import { BzTreeModule } from '../shared/components/tree/tree.module';
import { BzgTabsModule } from 'bz-genome-angular';
import { SharedModule } from './../shared/shared.module';

// This Module's Components
import { DataVisualizationComponent } from './datavisualization.component';
import { PowerBIComponent } from './dv-power-bi/dv-power-bi.component';
import { PowerBIDetailComponent } from './dv-power-bi/dv-power-bi-detail/dv-power-bi-detail.component';

// Services
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { PowerBIService } from './core/services/powerbi.service';
import { SafeHtmlPipe } from './safe-html.pipe';
import { TableauComponent } from './dv-tableau/dv-tableau.component';
import { TableauService } from './core/services/tableau.service';
import { TableauDetailComponent } from './dv-tableau/dv-tableau-detail/dv-tableau-detail.component';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        CommonModule,
        BzTabModule,
        InfiniteScrollModule,
        AccordionModule.forRoot(),
        BzSwitchModule,
        BrowserModule, FormsModule,
        BzTreeModule,
        BzgTabsModule,
        SharedModule
    ],
    declarations: [
      DataVisualizationComponent,
      PowerBIComponent,
      TableauComponent,
      PowerBIDetailComponent,
      TableauDetailComponent,
      SafeHtmlPipe
    ],
    exports: [
      DataVisualizationComponent,
      PowerBIComponent,
      PowerBIDetailComponent,
      TableauDetailComponent,
      TableauComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [PowerBIService, TableauService]
})
export class DataVisualizationModule { }
